import { Box, Button, Flex, Table, Tbody, Td, Text, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useGetTotalEmissions } from "../../../../../hooks/query/emissions-insight/emissions-insights-query";
import { ArrowLeft } from "@phosphor-icons/react";
import { ScopeCard } from "../SummaryCards";
import * as React from "react";
import { getFormattedNumValue } from "../../../../../utils";
import { H2 } from "../../../../../components/text/headings";
import { ConsumptionTable } from "./ScopeOneDetail";

const ScopeTwoDetail = ({ currentYearData, previousYearData, isFetchingCurrentYear, isFetchingPreviousYear }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleBack = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("detailView");
    setSearchParams(params);
  };

  return (
    <Flex direction="column" gap={4}>
      <Flex justifyContent="flex-start" mb={4}>
        <Button leftIcon={<ArrowLeft size={18} />} variant="plain" colorScheme="gray" onClick={handleBack}>
          Insights
        </Button>
      </Flex>

      <H2>Scope 2</H2>

      <Flex direction="row" gap={4} mb={6} width="100%">
        <ScopeCard
          title="Location"
          currentYear={currentYearData?.scope2LocationTotal}
          previousYear={previousYearData?.scope2LocationTotal}
          currentLoading={isFetchingCurrentYear}
          previousLoading={isFetchingPreviousYear}
          theme="dark"
        />
        <ScopeCard
          title="Market"
          currentYear={currentYearData?.scope2MarketTotal}
          previousYear={previousYearData?.scope2MarketTotal}
          currentLoading={isFetchingCurrentYear}
          previousLoading={isFetchingPreviousYear}
          theme="dark"
        />
      </Flex>

      <Flex p={4} gap={0} bg="gray.200" border="solid 1px" borderColor="gray.300" borderRadius="md">
        <ConsumptionTable title="Electricity" data={currentYearData?.scopeOneAndTwoDetail?.electricity} />
      </Flex>
    </Flex>
  );
};

export default ScopeTwoDetail;
